import { CompanyLogo } from '@/shared/components/CompanyLogo';
import { getRequestContext } from '@/shared/lib/requestContext';

export const CheckoutLogo = () => {
    const { company } = getRequestContext();

    return <CompanyLogo logo={company.companyLogo} position="header" alt="Логотип" />;
};
